exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div {\n  color:#cd3f27;\n  margin-top:2px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/control-messages/control-messages.component.css
// module id = ../../../../../src/app/control-messages/control-messages.component.css
// module chunks = main